import React, {PureComponent, Fragment} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import {Link} from 'react-router-dom';
import routes from '../../routes';
import {REPLY__16} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';
import {FormattedHTMLMessage} from 'react-intl';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {withTranslationsAsProps} from '../../components/translations';
import collaborateActions from '../collaborate/actions';
import onboardingActions from '../../components/onboarding/actions';
import edap from '../edap';

import './improved-empty-state.less';

export const ImprovedEmptyState = ({
    loginButtonLabel,
    signupButtonLabel,
    learnMoreLabel,
    loginUrl,
    loading,
    handleLoginClick,
    handleSignupClick,
    handleLearnMoreClick
}) => (
    <div className="improved-empty-state__wrapper">
        <div className="improved-empty-state__controls">
            <LoadingOverlay loading={loading} />
            <div className="improved-empty-state__title">
                <h2>
                    <FormattedHTMLMessage id={'tripboards.main.empty.startplan'} />
                </h2>
                <FormattedHTMLMessage id={'tripboards.main.empty.login.prompt'} />
            </div>
            <div className="improved-empty-state__controlRow">
                <Button onClick={handleLoginClick} href={loginUrl} label={loginButtonLabel} size={'sm'} />
                <ButtonPrimary onClick={handleSignupClick} href={loginUrl} label={signupButtonLabel} size={'sm'} />
            </div>
            <div className="improved-empty-state__learnMoreRow">
                <Link
                    to={routes.TRIPBOARD}
                    onClick={handleLearnMoreClick}
                    className="improved-empty-state__learnMoreLabel"
                >
                    <Fragment>
                        <SVGIcon markup={REPLY__16} />
                        <span className="improved-empty-state__learnMoreText">{learnMoreLabel}</span>
                    </Fragment>
                </Link>
            </div>
        </div>
        <div className="improved-empty-state-splash">
            <div className="improved-empty-state-splash__gray-circle" />

            <div className="improved-empty-state-splash__property-card-1 improved-empty-state-splash__board">
                <div className="header text-emphasis">
                    <FormattedHTMLMessage
                        id={'tripboards.main.empty.board4'}
                        defaultMessage={''}
                        description="Trip Board title 1"
                    />
                </div>
                <div className="left-content" />
                <div className="right-content">
                    <div className="right-content__top" />
                    <div className="right-content__bottom" />
                </div>
            </div>
            <div className="improved-empty-state-splash__property-card-2 improved-empty-state-splash__board">
                <div className="header text-emphasis">
                    <FormattedHTMLMessage
                        id={'tripboards.main.empty.board3'}
                        defaultMessage={''}
                        description="Trip Board title 2"
                    />
                </div>
                <div className="left-content" />
                <div className="right-content">
                    <div className="right-content__top" />
                    <div className="right-content__bottom" />
                </div>
            </div>
        </div>
    </div>
);

const mapDispatchToProps = {
    fetchLogin: collaborateActions.login,
    resetOnboarding: onboardingActions.resetOnBoardingFlags
};

const mapStateToProps = (state) => {
    const collaborateState =
        (state && state.tripboard && state.tripboard.collaborate && state.tripboard.collaborate.modal) || {};
    const systemState = (state && state.system) || {};
    return {
        loginUrl: collaborateState.loginUrl || '',
        loginFetchError: collaborateState.error,
        loginFetchLoading: collaborateState.loading,
        fullLocale: systemState.fullLocale,
        siteName: systemState.siteName
    };
};

class ImprovedEmptyStateWrapper extends PureComponent {
    constructor(props) {
        super(props);
        this.getLoginUrl = this.getLoginUrl.bind(this);
        this.handleLoginClick = this.handleLoginClick.bind(this);
        this.handleSignupClick = this.handleSignupClick.bind(this);
        this.handleLearnMoreClick = this.handleLearnMoreClick.bind(this);
        this.getLoginUrl();
    }

    componentDidUpdate() {
        this.getLoginUrl();
    }

    getLoginUrl() {
        const {loginFetchError, loginFetchLoading, fetchLogin, loginUrl, fullLocale, siteName} = this.props;
        if (fullLocale && siteName && !loginFetchError && !loginFetchLoading && !loginUrl) {
            fetchLogin(fullLocale, siteName);
        }
    }

    handleLoginClick() {
        edap.tripboardLogin();
    }

    handleSignupClick() {
        edap.tripboardSignup(); // lots of dupe with login click, but keeping it separate for future work
    }

    handleLearnMoreClick() {
        edap.learnMoreClick();
        this.props.resetOnboarding();
    }

    render() {
        const {
            title,
            description,
            loginButtonLabel,
            signupButtonLabel,
            loginUrl,
            loginFetchLoading,
            learnMoreLabel
        } = this.props;

        return (
            <ImprovedEmptyState
                title={title}
                description={description}
                signupButtonLabel={signupButtonLabel}
                loginButtonLabel={loginButtonLabel}
                learnMoreLabel={learnMoreLabel}
                loginUrl={loginUrl}
                loading={loginFetchLoading}
                handleLoginClick={this.handleLoginClick}
                handleSignupClick={this.handleSignupClick}
                handleLearnMoreClick={this.handleLearnMoreClick}
            />
        );
    }
}

export default compose(
    withTranslationsAsProps({
        'tripboards.invite.login': 'loginButtonLabel',
        'tripboards.invite.signup': 'signupButtonLabel',
        'sort.legal.linkText': 'learnMoreLabel'
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(ImprovedEmptyStateWrapper);



// WEBPACK FOOTER //
// ./src/universal/tripboard/improved-empty-state/improved-empty-state.js